import { Link } from 'react-router-dom';
import { Modal, StyledButton } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { ReactComponent as ImagePremium } from 'src/images/svgs/skills-matrix/premium.svg';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledModalContent } from './upgrade-to-premium-modal.styles';
export const UpgradeToPremiumModal = ({
  isModalOpen,
  setIsModalOpen
}: {
  isModalOpen: boolean;
  setIsModalOpen?: (arg: boolean) => void;
}) => {
  const [trackEvent] = useTrackEventMutation();
  const trackGoToSubscriptionClick = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'click-subscribe-skill'
    });
  };
  return <Modal onOpenChange={setIsModalOpen} open={isModalOpen} isSmall data-sentry-element="Modal" data-sentry-component="UpgradeToPremiumModal" data-sentry-source-file="upgrade-to-premium-modal.tsx">
      <StyledModalContent data-sentry-element="StyledModalContent" data-sentry-source-file="upgrade-to-premium-modal.tsx">
        <ImagePremium data-sentry-element="ImagePremium" data-sentry-source-file="upgrade-to-premium-modal.tsx" />
        <h1>
          Upgrade to <span>Premium</span> to unlock this skills matrix!
        </h1>
        <p>
          Subscribing gives you unlimited access to exclusive content, guided paths, and faster machines. Plus,
          you&apos;ll enjoy:
        </p>
        <ul>
          <li>
            <FontAwesomeIcon icon={faCheck} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="upgrade-to-premium-modal.tsx" /> Access to career specific skill matrices
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="upgrade-to-premium-modal.tsx" /> Personalized room recommendations
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="upgrade-to-premium-modal.tsx" /> View your skills progress
          </li>
        </ul>
        <StyledButton as={Link} variant="solid" color="primary" target="_blank" to="/why-subscribe" onClick={trackGoToSubscriptionClick} data-sentry-element="StyledButton" data-sentry-source-file="upgrade-to-premium-modal.tsx">
          Subscribe now
        </StyledButton>
      </StyledModalContent>
    </Modal>;
};